export const fixedIndexList = [
  { name: "None", label: "", value: "" },
  { name: "Internally Fixed", label: "Internally Fixed", value: "2a7680cd-467f-11e9-82f6-0242ac120002" },
  { name: "Treasurys", label: "Treasurys", value: "a81385fa-467d-11e9-82f6-0242ac120002" },
  { name: "Semi-Bond Swaps", label: "Semi-Bond Swaps", value: "ac46d8ac-467d-11e9-82f6-0242ac120002" }
];

export default {
  INTERNALLY_FIXED: "2a7680cd-467f-11e9-82f6-0242ac120002",
  TREASURYS: "a81385fa-467d-11e9-82f6-0242ac120002",
  SEMI_BOND_SWAPS: "ac46d8ac-467d-11e9-82f6-0242ac120002"
};
